import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '../../CustomTables';
import { Container, Row, Col, Card, CardBody, Form, Input } from 'reactstrap';
import { Btn, Alerts } from '../../AbstractElements';
import HeaderCard from '../../Components/Common/Component/HeaderCard';
import { addProject, deleteProject, getProject } from '../../Services/Settings.service';
import { DeleteButton, EditButton } from '../../CustomButton';
import { useNavigate } from "react-router-dom";
import CommonModal from '../../CommonModal';

const Projects = () => {

  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const [select, setSelect] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const [message, setMessage] = useState("");
  const [showError, setShowError] = useState(false); 
  const [update, setUpdate] = useState(false);

  const toggle = () => setConfirm(!confirm);

  const navigate = useNavigate();

  const tableColumns = [
    {
        name:'Actions',
        selector: (row) => 
            <div>
                <EditButton id={row.id} handleClick={handleEdit} />
                
                &nbsp;&nbsp;<DeleteButton id={row.id} confirm={confirmDelete} />
            </div>
    },
    {
      name: 'Nom',
      selector: (row) => row.name,
      sortable: true,
      filterable : true,
      
    },
  ];
  
  const handleDelete = () => {
    
    deleteProject(select).then((res) => {
        setMessage(res.message);
        setShowError(true);
    })
    setConfirm(false);
    setUpdate(true);
  }

  const handleEdit = (id) => {
    navigate("/EditProject/"+id);
  } 

  const confirmDelete = (id) => {
    setSelect(id)
    setConfirm(true);
  }

  useEffect(() => {
    getProject().then((result) => {
        setData(result)
        setUpdate(false);
    });
  }, [update])

  const newProject = (e) => {
    e.preventDefault();
    addProject({name:name}).then((res) => {
        setMessage(res.message);
        setShowError(true);
        setUpdate(true);
    })
  }

  return (
    <Fragment>
      <Container fluid={true} className="datatables">
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Gestion des projets"/>
              <CardBody>
                    {showError && (<Alerts attrAlert={{color:'primary '}} children={message} />)}
                    <CommonModal isOpen={confirm} 
                                 toggler={toggle} 
                                 title="Supression" 
                                 action={handleDelete}
                                 message="Voulez-vous vraiment suprrimer ce projet ?"/>
                    <Form className="needs-validation" noValidate="" onSubmit={newProject}>
                        <Row className="g-3">
                            <Col md='3'>
                                <Input 
                                    className="form-control" 
                                    name="name" 
                                    type="text" 
                                    required={true} 
                                    placeholder="libellé" 
                                    onChange={(e) => setName(e.target.value)}
                                    />
                            </Col>
                            <Col md='3'>
                                <Btn attrBtn={{ className: 'btn-block', color: 'primary', type: 'submit' }}>Ajouter</Btn>
                            </Col>
                        </Row>
                    </Form>        
                    <div className='table-responsive display' style={{marginTop: '2%' }}>
                        <CustomTable
                            data={data}
                            columns={tableColumns}
                        />
                    </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

};

export default Projects;